module.exports = __webpack_public_path__ + "static/media/toolbar_go_m_white_i.e56e3dae.png";